import Button from "components/presenters/button/Button";
import { replace } from "lodash";
import styled from "styled-components";

export default function RetryButton({ productNo }) {
  return (
    <BottomButton
      to={`/motishop/product/${productNo}`}
      fullwidth={"true"}
      replace
    >{`결제 다시하기`}</BottomButton>
  );
}

const BottomButton = styled(Button)`
  position: absolute;
  bottom: 0%;
  background-color: #ffcf19;
  font-size: calc(100vw * (18 / 375));
  font-weight: 700;
  line-height: calc(100vw * (26.06 / 375));
  color: #121212;
  padding: calc(100vw * (23 / 375)) 0;
  text-align: center;
`;
